export const breadcrumbNameMap: { [key: string]: string } = {
  '/empresas/consulta_de_empresa': 'Consulta de Empresa',
  '/pedidos/cartao': 'Pedido de cartão',
  '/pedidos/recarga': 'Pedido de recarga',
  '/financeiro': 'Gestão financeira',
}
